import React from 'react';
import { FadeIn } from './ui/FadeIn';

export function About() {
  return (
    <section id="about" className="py-section-mob md:py-section-desk max-w-content mx-auto px-pad-mob md:px-pad-desk bg-paper">
      <div className="flex flex-col md:flex-row gap-16 md:gap-8 relative">
        <div className="md:w-[30%] relative">
          <FadeIn className="md:sticky md:top-32 font-mono text-caption text-graphite uppercase space-y-8">
            <div>
              <p className="text-ink/40 mb-1">BYLINE</p>
              <p className="text-ink">Md Abu Musa</p>
            </div>
            <div>
              <p className="text-ink/40 mb-1">BASED IN</p>
              <p className="text-ink">[PARTNER FILLS, e.g., Dhaka, Bangladesh]</p>
            </div>
            <div>
              <p className="text-ink/40 mb-1">WRITING SINCE</p>
              <p className="text-ink">[PARTNER FILLS, e.g., 2004]</p>
            </div>
            <div>
              <p className="text-ink/40 mb-1">CONSULTING SINCE</p>
              <p className="text-ink">[PARTNER FILLS, e.g., 2020]</p>
            </div>
          </FadeIn>
        </div>
        <div className="md:w-[70%] max-w-prose-block">
          <FadeIn>
            <h2 className="font-heading text-h2-mob md:text-h2-desk text-ink mb-12">
              The Journalist Who Started Reading Sales Emails
            </h2>
          </FadeIn>
          <FadeIn delay={0.1} className="font-body text-body-base text-ink space-y-6">
            <p className="dropcap">
              For more than two decades I made a living asking strangers questions. I interviewed prime ministers and panel-beaters. I filed to deadline from places with no electricity. I learned, very quickly, that the first sentence decides whether anyone reads the second.
            </p>
            <p>
              Around five years ago I started paying attention to a different kind of writing, the cold emails landing in my inbox. Most of them were terrible. A few were brilliant. The brilliant ones used the exact techniques I'd spent my career sharpening: specific research, a real reason to reach out, and one clean ask.
            </p>
            <p>
              So I started helping founders write theirs. Then I started helping them build lists. Then systems. Then strategies.
            </p>
          </FadeIn>
          <FadeIn delay={0.2} className="my-12 pl-6 border-l-2 border-ink">
            <p className="font-heading italic text-[28px] leading-snug text-ink">
              "I'm not an agency. I'm one senior operator who happens to write for a living, and who'll sit with you until your outbound actually makes sense."
            </p>
          </FadeIn>
          <FadeIn delay={0.3}>
            <p className="font-body text-body-base text-ink">
              Today I work with founders of small B2B companies, usually between 2 and 50 people, who are tired of lead-gen agencies that burn lists and call it a strategy. If that's you, the calendar is below.
            </p>
          </FadeIn>
        </div>
      </div>
    </section>
  );
}